import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedService } from 'src/app/shared/services/shared.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { BottomFooterComponent } from '../bottom-footer/bottom-footer.component';
import { TopNavbarComponent } from '../top-navbar/top-navbar.component';

@Component({
  selector: 'app-contact',
  standalone: true,
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
  imports: [ReactiveFormsModule, NgSelectModule, TopNavbarComponent, BottomFooterComponent]
})
export class ContactComponent {
  contactForm: FormGroup;

  reasons = [
    { id: 'general', name: 'General Inquiry' },
    { id: 'support', name: 'Support' },
    { id: 'sales', name: 'Sales' },
    { id: 'partnership', name: 'Partnership' },
    { id: 'feedback', name: 'Feedback' }
  ];

  constructor(
    public sharedService: SharedService, 
    private fb: FormBuilder
  ) {
    this.contactForm = this.fb.group({
      name: ['John Doe', Validators.required],
      position: ['Marketing Manager', Validators.required],
      company: ['Acme Corp', Validators.required],
      email: ['john@example.com', [Validators.required, Validators.email]],
      phone: ['(555) 123-4567', [
        Validators.required,
        Validators.pattern(/^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,9}$/)
      ]],
      contactMethod: ['email', Validators.required],
      reason: [null, Validators.required],
      message: ['', Validators.required]
    });
  }

  ngOnInit() {}
 onSubmit() {
    if (this.contactForm.valid) {
      console.log('Form Submitted!', this.contactForm.value);
      alert('Message sent!');
    } else {
      // ensure UI shows validation states
      this.markAllControlsTouched(this.contactForm);

      // list invalid control names/paths
      const invalidControls = this.findInvalidControlsRecursive(this.contactForm);
      console.warn('Invalid controls:', invalidControls);
      // optionally show first invalid control
      const firstInvalid = invalidControls[0];
      if (firstInvalid) {
        console.warn('First invalid control:', firstInvalid);
      }
    }
  }
   private markAllControlsTouched(form: FormGroup | any): void {
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      if (control instanceof FormGroup || control instanceof Array) {
        this.markAllControlsTouched(control);
      } else {
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }
   private findInvalidControlsRecursive(form: FormGroup | any, prefix = ''): string[] {
    const invalid: string[] = [];
    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);
      const path = prefix ? `${prefix}.${key}` : key;
      if (control instanceof FormGroup || control instanceof Array) {
        invalid.push(...this.findInvalidControlsRecursive(control, path));
      } else if (control && control.invalid) {
        invalid.push(path);
      }
    });
    return invalid;
  }

}